import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
import { recentPurchases } from '../data/recentPurchases';
const FIRST_DELAY = 10000;
const INTERVAL = 120000;
const VISIBLE_FOR = 7000;
export function PurchaseNotifications() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    const show = () => {
      setVisible(true);
      hideTimer = window.setTimeout(() => {
        setVisible(false);
        setIndex(current => (current + 1) % recentPurchases.length);
      }, VISIBLE_FOR);
    };
    const firstTimer = window.setTimeout(show, FIRST_DELAY);
    const interval = window.setInterval(show, INTERVAL);
    return () => {
      window.clearTimeout(firstTimer);
      window.clearTimeout(hideTimer);
      window.clearInterval(interval);
    };
  }, [dismissed]);
  const purchase = recentPurchases[index];
  return <AnimatePresence data-id="element-243" data-mp="tm4ss2yezzgd">
      {visible && !dismissed ? <motion.div initial={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} transition={{
      duration: 0.25,
      ease: [0.22, 1, 0.36, 1]
    }} className="fixed bottom-24 left-4 z-50 flex max-w-[19rem] items-start gap-3 rounded-2xl border border-white/10 bg-ink-900/95 p-4 shadow-[0_20px_50px_-20px_rgba(0,0,0,0.9)] backdrop-blur lg:bottom-6 lg:left-6" role="status" aria-live="polite" data-id="element-244" data-mp="ostifrue90jp">
          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-gold/15" data-id="element-245" data-mp="12n2vmhx4a0xd">
            <ShoppingBagIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-246" data-mp="ylhf8mldj4if" />
          </span>
          <div className="pr-4" data-id="element-247" data-mp="3n94frsgn2u9r">
            <p className="text-xs font-semibold text-white sm:text-sm" data-id="element-248" data-mp="3j9424a1d6n3r">
              {purchase.name} de {purchase.city} compró Diccionario Apple
            </p>
            <p className="mt-1 text-[11px] text-white/45" data-id="element-249" data-mp="3kopwlm8fjmeu">hace {purchase.minutesAgo} minutos</p>
          </div>
          <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar aviso" className="absolute right-2 top-2 rounded-full p-1 text-white/35 transition-colors hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-accent" data-id="element-250" data-mp="3pnjcflb6vpi6">
            <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-251" data-mp="36qrogykpcm7s" />
          </button>
        </motion.div> : null}
    </AnimatePresence>;
}